import React from 'react';
import { Link } from 'react-router-dom';

const s: React.CSSProperties = {
  maxWidth: '760px',
  margin: '0 auto',
  padding: '2rem 1.5rem 4rem',
  lineHeight: '1.7',
};
const h1s: React.CSSProperties = { fontSize: '1.75rem', fontWeight: 700, marginBottom: '0.25rem' };
const metas: React.CSSProperties = { color: '#6b7280', marginBottom: '2rem', fontSize: '0.9rem' };
const h2s: React.CSSProperties = { fontSize: '1.1rem', fontWeight: 700, marginTop: '2rem', marginBottom: '0.5rem' };
const ps: React.CSSProperties = { marginBottom: '0.75rem' };
const ols: React.CSSProperties = { paddingLeft: '1.5rem', marginBottom: '0.75rem' };
const uls: React.CSSProperties = { paddingLeft: '1.5rem', marginBottom: '0.75rem' };
const hrs: React.CSSProperties = { border: 'none', borderTop: '1px solid #e5e7eb', margin: '2rem 0' };
const backs: React.CSSProperties = { display: 'inline-block', marginBottom: '1.5rem', color: '#6b7280', fontSize: '0.875rem', textDecoration: 'none' };

const DataDeletion: React.FC = () => (
  <div style={s}>
    <Link to="/" style={backs}>← Back</Link>
    <h1 style={h1s}>Data Deletion Instructions</h1>
    <p style={metas}>Barkada — Operated by Librio LLC</p>

    <hr style={hrs} />

    <h2 style={h2s}>1. Delete Your Account In-App</h2>
    <p style={ps}>The easiest way to delete your data is directly through the app:</p>
    <ol style={ols}>
      <li>Log in to your account at www.barkada.us</li>
      <li>Go to your Profile page</li>
      <li>Click Edit Profile</li>
      <li>Click the Delete Account button</li>
      <li>Enter your password to confirm</li>
    </ol>
    <p style={ps}>Upon deletion, all your personal data will be permanently removed from our systems within 30 days.</p>

    <h2 style={h2s}>2. Request Manual Deletion</h2>
    <p style={ps}>If you are unable to access your account, you can request data deletion by emailing us at <a href="mailto:info@barkada.us">info@barkada.us</a> with the subject line "Data Deletion Request" and your registered email address. We will process your request within 30 days.</p>

    <h2 style={h2s}>3. What Gets Deleted</h2>
    <p style={ps}>When your account is deleted, we permanently remove:</p>
    <ul style={uls}>
      <li>Your profile and account information</li>
      <li>Your activity listings and squad memberships</li>
      <li>Your messages and connections</li>
      <li>All other personal data associated with your account</li>
    </ul>
  </div>
);

export default DataDeletion;
